"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractStates;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _globals = require("../../globals.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function extractStates(style) {
  var _ref;

  style = style || {};
  var shared = (0, _omit["default"])(style, [_globals.STATE.FOCUS, _globals.STATE.DISABLED, _globals.STATE.ERROR, _globals.STATE.HOVER]);
  return _ref = {}, (0, _defineProperty2["default"])(_ref, _globals.STATE.IDLE, shared), (0, _defineProperty2["default"])(_ref, _globals.STATE.FOCUS, _objectSpread({}, shared, {}, style[_globals.STATE.FOCUS] || {})), (0, _defineProperty2["default"])(_ref, _globals.STATE.HOVER, _objectSpread({}, shared, {}, style[_globals.STATE.HOVER] || {})), (0, _defineProperty2["default"])(_ref, _globals.STATE.ERROR, _objectSpread({}, shared, {}, style[_globals.STATE.ERROR] || {})), (0, _defineProperty2["default"])(_ref, _globals.STATE.DISABLED, _objectSpread({}, shared, {}, style[_globals.STATE.DISABLED] || {})), _ref;
}